import { Card, Table } from "antd";
import { ColumnsType } from "antd/lib/table";

import styles from "../index.module.less";
import Loading from "../../common/Loading";

import type { keyFobStatusList } from "../../../shared/interface/dashboard.interface";

interface KeyFobStatusCardProps {
  data: keyFobStatusList[];
  loading: boolean;
  isFullScreen?: boolean;
}

const KeyFobStatusCard = (props: KeyFobStatusCardProps) => {
  const columns: ColumnsType<keyFobStatusList> = [
    {
      align: "center",
      title: "",
      key: "vehicle",
      dataIndex: "vehicle_type_name",
      render: (text) => <div>{text ?? "-"}</div>,
      width: "35%",
      onCell: () => ({
        className: styles["table-cell-small"]
      })
    },
    {
      align: "center",
      title: "Allocated",
      key: "assigned_count",
      dataIndex: "assigned_count",
      render: (text) => <div>{text ?? "-"}</div>,
      onCell: () => ({
        className: styles["table-cell-small"]
      })
    },
    {
      align: "center",
      title: "Not Allocated",
      key: "unassigned_count",
      dataIndex: "unassigned_count",
      render: (text) => <div>{text ?? "-"}</div>,
      onCell: () => ({
        className: styles["table-cell-small"]
      })
    }
  ];

  const renderUI = () => (
    <>
      <div className={props?.isFullScreen ? styles["card-header-full-screen"] : styles["card-header"]}>{"KeyFob Status"}</div>
      {props?.loading ? (
        <Loading />
      ) : !props?.loading && props?.data?.length > 0 ? (
        <Table
          scroll={{ y: props?.isFullScreen ? "75vh" : "23vh" }}
          className={`gx-table-responsive`}
          columns={columns}
          dataSource={props?.data}
          bordered
          rowKey="sr_no"
          pagination={false}
          size="small"
          components={{
            header: {
              cell: (props: React.HTMLProps<HTMLTableCellElement>) => <th {...props} className={`${props.className} ${styles["custom-table-header"]}`} />
            }
          }}
        />
      ) : (
        <svg width="100%">
          <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="h3">
            No data available!
          </text>
        </svg>
      )}
    </>
  );

  return props?.isFullScreen ? (
    <div className="gx-text-center gx-p-2">{renderUI()}</div>
  ) : (
    <Card title={null} bodyStyle={{ padding: "15px" }} className={`gx-card gx-text-center ${styles["card-container"]}`}>
      {renderUI()}
    </Card>
  );
};

export default KeyFobStatusCard;
